import router from "@/router";

export function resolverDestinoNotificacion(item) {
  const DESTINO = {
    tramite: "/home-agentes",
    tarea: "/tareas",
    turno: "/turnero",
  };

  let tipo, id, destino;

  if (item.task?.id) {
    if (item.task.completed === true && item.procedureHistory?.id) {
      tipo = "tramite";
      id = item.procedureHistory.id;
      destino = DESTINO.tramite;
    } else {
      tipo = "tarea";
      id = item.task.id;
      destino = DESTINO.tarea;
    }
  } else if (item.procedureHistory?.id) {
    tipo = "tramite";
    id = item.procedureHistory.id;
    destino = DESTINO.tramite;
  } else if (item.appointmentHistory?.id) {
    tipo = "turno";
    id = item.appointmentHistory.id;
    destino = DESTINO.turno;
  } else {
    return null;
  }

  return { tipo, id, destino };
}

export function navegarDesdeNotificacion(item) {
  const res = resolverDestinoNotificacion(item);
  if (!res) return;

  const { tipo, id } = res;

  if (tipo === "tarea") {
    router.push({ name: "tarea-notification", params: { id } });
    return;
  }

  if (tipo === "tramite") {
    router.push({ name: "tramite-notification", params: { id } });
    return;
  }

  router.push({
    path: res.destino,
    query: { abrir: tipo, id },
  });
}
